export default "__VITE_PUBLIC_ASSET__14b2274e__"